import {mergeMap as _observableMergeMap, catchError as _observableCatch, } from "rxjs/operators";
import {Observable,throwError as _observableThrow,of as _observableOf,of, observable} from "rxjs";   
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";  
import {HttpClient, HttpHeaders, HttpResponse,HttpResponseBase} from "@angular/common/http";
import { API_BASE_URL, BaseClient } from "./baseclient";
import { ProblemDetails } from "../models/problemdetails";
import { UserLoginRequest } from "../models/userloginrequest";
import { TokenResponse } from "../models/tokenresponse";
import { UserResponse } from "../models/UserReponse";
import { PasswordResetRequest } from "../models/PasswordResetRequest";
import { UserPinRequest } from "../models/userpinrequest";

@Injectable({
    providedIn: "root",
  })
export class OneTimePinClient extends  BaseClient
{
    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
       super(http,baseUrl);
   
    }
     isOneTimePinEnabled(userLoginDto: UserLoginRequest): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/authentication/login";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(userLoginDto);
    
        let options_: any = {
          body: content_,
          observe: "response",
          responseType: "blob",
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Accept: "application/json",
          }),
        };
    
        return this.http
          .request("post", url_, options_)
          .pipe(
            _observableMergeMap((response_: any) => {
              return this.processAuthenticate(response_);
            })
          )
          .pipe(
            _observableCatch((response_: any) => {
              if (response_ instanceof HttpResponseBase) {
                try {
                  return this.processAuthenticate(response_ as any);
                } catch (e) {
                  return _observableThrow(e) as any as Observable<TokenResponse>;
                }
              } else
                return _observableThrow(
                  response_
                ) as any as Observable<TokenResponse>;
            })
          );
      }
    
      protected processAuthenticate(
        response: HttpResponseBase
      ): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
          response instanceof HttpResponse
            ? response.body
            : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;
    
        let _headers: any = {};
        if (response.headers) {
          for (let key of response.headers.keys()) {
            _headers[key] = response.headers.get(key);
          }
        }
        if (status === 200) {
          return this.blobToText(responseBlob).pipe(
            _observableMergeMap((_responseText) => {
              let result200: any = null;
              let resultData200 =
                _responseText === ""
                  ? null
                  : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = TokenResponse.fromJS(resultData200);
              return _observableOf(result200);
            })
          );
        } else if (status === 400 || status === 401 || status === 404) {
          return this.blobToText(responseBlob).pipe(
            _observableMergeMap((_responseText) => {
              return this.throwException(
                "Invalid or missing parameters",
                status,
                _responseText,
                _headers
              );
            })
          );
        } else if (status !== 200 && status !== 204) {
          return this.blobToText(responseBlob).pipe(
            _observableMergeMap((_responseText) => {
              return this.throwException(
                "An unexpected server error occurred.",
                status,
                _responseText,
                _headers
              );
            })
          );
        }
        return _observableOf<TokenResponse>(null as any);
      }
      validateOneTimePin(pinRequest: UserPinRequest): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/authentication/validatepin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pinRequest);
       
        let options_: any = {
          body: content_,
          observe: "response",
          responseType: "blob",
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Accept: "application/json",
          }),
        };

        return this.http
          .request("post", url_, options_)
          .pipe(
            _observableMergeMap((response_: any) => {
              return this.processAuthenticate(response_);
            })
          )
          .pipe(
            _observableCatch((response_: any) => {
              if (response_ instanceof HttpResponseBase) {
                try {
                  return this.processAuthenticate(response_ as any);
                } catch (e) {
                  return _observableThrow(e) as any as Observable<TokenResponse>;
                }
              } else
                return _observableThrow(
                  response_
                ) as any as Observable<TokenResponse>;
            })
          );
      }
}